import { ClaimType, Popover, PopoverItem } from '../../../../core/src/index';
import { mdiMenuDown } from '@mdi/js';
import _ from 'lodash';
import React from 'react';
import * as S from './claim-type-select.styles';

interface IClaimTypeSelectProps {
    className?: string;
    value: ClaimType[];
    onChange: (type: ClaimType) => void;
}

export const ClaimTypeSelect: React.FunctionComponent<IClaimTypeSelectProps> = (props: IClaimTypeSelectProps) => {
    const { className, onChange, value } = props;
    const options = [
        { type: ClaimType.PROFESSIONAL, label: ClaimType.PROFESSIONAL },
        { type: ClaimType.INSTITUTIONAL, label: ClaimType.INSTITUTIONAL },
    ];
    const renderButton = () => {
        const selectedValues = options.filter(option => value.includes(option.type));
        return (
            <S.Select>
                {selectedValues.map(val => val.label).join(', ')}
                <S.SelectIcon path={mdiMenuDown} />
            </S.Select>
        );
    };
    const renderItems = () => {
        return _.map(options, option => (
            <PopoverItem
                key={option.type}
                selected={value.includes(option.type)}
                selectable={true}
                onClick={handleClick(option.type as ClaimType)}>
                {option.label}
            </PopoverItem>
        ));
    };
    const handleClick = (type: ClaimType) => {
        return () => {
            onChange(type);
        };
    };
    return (
        <Popover className={className} renderButton={renderButton} selectable={true}>
            {renderItems()}
        </Popover>
    );
};
